var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _g3, _g4, _path9, _path10, _path11, _path12, _g5, _g6, _path13, _path14, _path15, _path16, _g7, _g8, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllProjectsThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V145C1 148.314 3.68629 151 7 151H201C204.314 151 207 148.314 207 145V7C207 3.6863 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.585 31H96.0003C97.6572 31 99.0003 32.3431 99.0003 34C99.0003 35.6569 97.6572 37 96.0003 37H80.585V31Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34C78 32.3431 79.3431 31 81 31H88.3385V37H81C79.3431 37 78 35.6569 78 34Z",
    fill: "#D1D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.658 30.918C186.625 30.918 186.592 30.9252 186.561 30.9368C186.294 31.0364 185.78 31.1015 185.45 31.1015C184.75 31.1015 183.95 30.8262 183.15 30.6059C182.3 30.2754 181.4 30 180.55 30C180.35 30 180.15 30.0551 180 30.0551C179.448 30.0551 179 30.5028 179 31.0551V38.6429C179 38.919 179.224 39.1429 179.5 39.1429C179.776 39.1429 180 38.919 180 38.6429V36.7324C180 36.3938 180.211 36.0585 180.55 36.0585C181.25 36.0585 182.05 36.3339 182.85 36.5542C183.7 36.8296 184.6 37.105 185.45 37.105C185.9 37.105 186.35 36.9948 186.7 36.8296C186.885 36.728 186.998 36.5325 186.994 36.3219L186.898 31.1532C186.896 31.0226 186.789 30.918 186.658 30.918Z",
    fill: "#D1D1D1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11961_88502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.709 27.916H120.959V42.0827H116.709V27.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.376 27.916H126.626V42.0827H122.376V27.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 27.916H132.292V42.0827H128.042V27.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 27.916H137.959V42.0827H133.709V27.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 27.916H143.626V42.0827H139.376V27.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.042 27.916H149.292V42.0827H145.042V27.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.709 27.916H154.959V42.0827H150.709V27.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.376 27.916H160.626V42.0827H156.376V27.916Z",
    fill: "#E1E1E1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11961_88502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.709 35.4297H120.959V42.0819H116.709V35.4297Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.376 37.0938H126.626V42.0829H122.376V37.0938Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 39.8652H132.292V42.0826H128.042V39.8652Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 40.666H137.959V42.0827H133.709V40.666Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 35.707H143.626V42.082H139.376V35.707Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.042 32.166H149.292V42.0827H145.042V32.166Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.709 39.957H154.959V42.082H150.709V39.957Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.376 33.582H160.626V42.082H156.376V33.582Z",
    fill: "#D1D1D1"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 29C21.8954 29 21 29.8954 21 31V37C21 38.1046 21.8954 39 23 39H49C50.1046 39 51 38.1046 51 37V31C51 29.8954 50.1046 29 49 29H23Z",
    fill: "#DFE0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.585 59H96.0003C97.6572 59 99.0003 60.3431 99.0003 62C99.0003 63.6569 97.6572 65 96.0003 65H80.585V59Z",
    fill: "#E1E1E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62C78 60.3431 79.3431 59 81 59H88.3385V65H81C79.3431 65 78 63.6569 78 62Z",
    fill: "#D1D1D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.658 58.918C186.625 58.918 186.592 58.9252 186.561 58.9368C186.294 59.0364 185.78 59.1015 185.45 59.1015C184.75 59.1015 183.95 58.8262 183.15 58.6059C182.3 58.2754 181.4 58 180.55 58C180.35 58 180.15 58.0551 180 58.0551C179.448 58.0551 179 58.5028 179 59.0551V66.6429C179 66.919 179.224 67.1429 179.5 67.1429C179.776 67.1429 180 66.919 180 66.6429V64.7324C180 64.3938 180.211 64.0585 180.55 64.0585C181.25 64.0585 182.05 64.3339 182.85 64.5542C183.7 64.8296 184.6 65.105 185.45 65.105C185.9 65.105 186.35 64.9948 186.7 64.8296C186.885 64.728 186.998 64.5325 186.994 64.3219L186.898 59.1532C186.896 59.0226 186.789 58.918 186.658 58.918Z",
    fill: "#D1D1D1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11961_88502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.709 55.916H120.959V70.0827H116.709V55.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.376 55.916H126.626V70.0827H122.376V55.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 55.916H132.292V70.0827H128.042V55.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 55.916H137.959V70.0827H133.709V55.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 55.916H143.626V70.0827H139.376V55.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.042 55.916H149.292V70.0827H145.042V55.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.709 55.916H154.959V70.0827H150.709V55.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.376 55.916H160.626V70.0827H156.376V55.916Z",
    fill: "#E1E1E1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11961_88502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.709 63.4297H120.959V70.0819H116.709V63.4297Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.376 65.0938H126.626V70.0829H122.376V65.0938Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 67.8652H132.292V70.0826H128.042V67.8652Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 68.666H137.959V70.0827H133.709V68.666Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 63.707H143.626V70.082H139.376V63.707Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.042 60.166H149.292V70.0827H145.042V60.166Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.709 67.957H154.959V70.082H150.709V67.957Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.376 61.582H160.626V70.082H156.376V61.582Z",
    fill: "#D1D1D1"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 57C21.8954 57 21 57.8954 21 59V65C21 66.1046 21.8954 67 23 67H49C50.1046 67 51 66.1046 51 65V59C51 57.8954 50.1046 57 49 57H23Z",
    fill: "#DFE0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.585 87H96.0003C97.6572 87 99.0003 88.3431 99.0003 90C99.0003 91.6569 97.6572 93 96.0003 93H80.585V87Z",
    fill: "#E1E1E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90C78 88.3431 79.3431 87 81 87H88.3385V93H81C79.3431 93 78 91.6569 78 90Z",
    fill: "#D1D1D1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.658 86.918C186.625 86.918 186.592 86.9252 186.561 86.9368C186.294 87.0364 185.78 87.1015 185.45 87.1015C184.75 87.1015 183.95 86.8262 183.15 86.6059C182.3 86.2754 181.4 86 180.55 86C180.35 86 180.15 86.0551 180 86.0551C179.448 86.0551 179 86.5028 179 87.0551V94.6429C179 94.919 179.224 95.1429 179.5 95.1429C179.776 95.1429 180 94.919 180 94.6429V92.7324C180 92.3938 180.211 92.0585 180.55 92.0585C181.25 92.0585 182.05 92.3339 182.85 92.5542C183.7 92.8296 184.6 93.105 185.45 93.105C185.9 93.105 186.35 92.9948 186.7 92.8296C186.885 92.728 186.998 92.5325 186.994 92.3219L186.898 87.1532C186.896 87.0226 186.789 86.918 186.658 86.918Z",
    fill: "#D1D1D1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11961_88502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.709 83.916H120.959V98.0827H116.709V83.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.376 83.916H126.626V98.0827H122.376V83.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 83.916H132.292V98.0827H128.042V83.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 83.916H137.959V98.0827H133.709V83.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 83.916H143.626V98.0827H139.376V83.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.042 83.916H149.292V98.0827H145.042V83.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.709 83.916H154.959V98.0827H150.709V83.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.376 83.916H160.626V98.0827H156.376V83.916Z",
    fill: "#E1E1E1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11961_88502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.709 91.4297H120.959V98.0819H116.709V91.4297Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.376 93.0938H126.626V98.0829H122.376V93.0938Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 95.8652H132.292V98.0826H128.042V95.8652Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 96.666H137.959V98.0827H133.709V96.666Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 91.707H143.626V98.082H139.376V91.707Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.042 88.166H149.292V98.0827H145.042V88.166Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.709 95.957H154.959V98.082H150.709V95.957Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.376 89.582H160.626V98.082H156.376V89.582Z",
    fill: "#D1D1D1"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 85C21.8954 85 21 85.8954 21 87V93C21 94.1046 21.8954 95 23 95H49C50.1046 95 51 94.1046 51 93V87C51 85.8954 50.1046 85 49 85H23Z",
    fill: "#DFE0E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.585 115H96.0003C97.6572 115 99.0003 116.343 99.0003 118C99.0003 119.657 97.6572 121 96.0003 121H80.585V115Z",
    fill: "#E1E1E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78 118C78 116.343 79.3431 115 81 115H88.3385V121H81C79.3431 121 78 119.657 78 118Z",
    fill: "#D1D1D1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.658 114.918C186.625 114.918 186.592 114.925 186.561 114.937C186.294 115.036 185.78 115.102 185.45 115.102C184.75 115.102 183.95 114.826 183.15 114.606C182.3 114.275 181.4 114 180.55 114C180.35 114 180.15 114.055 180 114.055C179.448 114.055 179 114.503 179 115.055V122.643C179 122.919 179.224 123.143 179.5 123.143C179.776 123.143 180 122.919 180 122.643V120.732C180 120.394 180.211 120.059 180.55 120.059C181.25 120.059 182.05 120.334 182.85 120.554C183.7 120.83 184.6 121.105 185.45 121.105C185.9 121.105 186.35 120.995 186.7 120.83C186.885 120.728 186.998 120.533 186.994 120.322L186.898 115.153C186.896 115.023 186.789 114.918 186.658 114.918Z",
    fill: "#D1D1D1"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_11961_88502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.709 111.916H120.959V126.083H116.709V111.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.376 111.916H126.626V126.083H122.376V111.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 111.916H132.292V126.083H128.042V111.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 111.916H137.959V126.083H133.709V111.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 111.916H143.626V126.083H139.376V111.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.042 111.916H149.292V126.083H145.042V111.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.709 111.916H154.959V126.083H150.709V111.916Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.376 111.916H160.626V126.083H156.376V111.916Z",
    fill: "#E1E1E1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_11961_88502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.709 119.43H120.959V126.082H116.709V119.43Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.376 121.094H126.626V126.083H122.376V121.094Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.042 123.865H132.292V126.083H128.042V123.865Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.709 124.666H137.959V126.083H133.709V124.666Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 119.707H143.626V126.082H139.376V119.707Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.042 116.166H149.292V126.083H145.042V116.166Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.709 123.957H154.959V126.082H150.709V123.957Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.376 117.582H160.626V126.082H156.376V117.582Z",
    fill: "#D1D1D1"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 113C21.8954 113 21 113.895 21 115V121C21 122.105 21.8954 123 23 123H49C50.1046 123 51 122.105 51 121V115C51 113.895 50.1046 113 49 113H23Z",
    fill: "#DFE0E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11961_88502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9167,
    height: 14.1667,
    fill: "white",
    transform: "translate(116.709 27.916)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11961_88502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9167,
    height: 9.91667,
    fill: "white",
    transform: "translate(116.709 32.166)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11961_88502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9167,
    height: 14.1667,
    fill: "white",
    transform: "translate(116.709 55.916)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11961_88502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9167,
    height: 9.91667,
    fill: "white",
    transform: "translate(116.709 60.166)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11961_88502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9167,
    height: 14.1667,
    fill: "white",
    transform: "translate(116.709 83.916)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11961_88502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9167,
    height: 9.91667,
    fill: "white",
    transform: "translate(116.709 88.166)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_11961_88502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9167,
    height: 14.1667,
    fill: "white",
    transform: "translate(116.709 111.916)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_11961_88502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9167,
    height: 9.91667,
    fill: "white",
    transform: "translate(116.709 116.166)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProjectsThumbnail);
export default __webpack_public_path__ + "static/media/all-projects-thumbnail.568eb28d92e3e0efa03d4c2fe69a6888.svg";
export { ForwardRef as ReactComponent };